import React, {useContext, useEffect} from 'react'
import { Route, Redirect } from 'react-router'
import LoginContext from '../context/Login/LoginContext'

const PrivateRoute = ({component: Component, ...props}) => {

  const loginContext = useContext(LoginContext)
  const {authentication, ReturnAuth} = loginContext

  useEffect(() => {
    ReturnAuth()
    // eslint-disable-next-line
  }, [])

  return (
    <Route {...props} render={ props => !authentication  ?   (
      <Redirect to="/credito" />
    ):(
      <Component {...props} />
    )}/>
  )
}

export default PrivateRoute
